/*
 * Jira Ticket:
 * Created Date: Mon, 19th Aug 2019, 11:26:30 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2019 The Distance
 */

const downloadFile = ({ uri, filename }) => {
  let link = document.createElement('a');
  link.href = uri;
  link.target = '_blank';
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadFile;
